import { render, staticRenderFns } from "./SubscriptionPrices.vue?vue&type=template&id=3acc09a6&"
import script from "./SubscriptionPrices.vue?vue&type=script&lang=ts&"
export * from "./SubscriptionPrices.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports